import { CartItemsFragment } from '@graphcommerce/magento-cart-items'
import { nonNullable } from '@graphcommerce/next-ui'

type UsePromotionsProps = Pick<CartItemsFragment, 'items'>

export function usePromotions(props: UsePromotionsProps) {
  const { items } = props
  const promotions: { [key: string]: number } = {}
  items?.filter(nonNullable).forEach(
    (item) =>
      item.product.promotion_id &&
      Object.assign(promotions, {
        [item?.product.promotion_id]: promotions[item.product.promotion_id]
          ? promotions[item.product.promotion_id] + item.quantity
          : item.quantity,
      }),
  )

  return promotions
}
